import { useCallback } from "react"
import { getPeriod, getTotalTimer } from "../sports/rules.js"

export const useButtonTimer = ({match, timerValue}) => {

    const getTimer = useCallback(() => {
        if(match.statusTimer === 'off'){
            if(match.status==='end' || (['soccer', 'rugby'].includes(match.discipline) && (match.period === 2 || match.period === 6)))
                return 'Fin du match'

                if(['handball'].includes(match.discipline)){
                    const currPeriod = getPeriod(match.period, match.discipline);
                        if (!currPeriod.isPlayable){
                           return currPeriod.name;
                        }
                }else{

                    if(match.period === 0 && timerValue===0)
                    return 'Coup d\'envoi'
    
                if(['basket'].includes(match.discipline) && timerValue===0)
                    return 'Quart-temps'
                
                if((match.period === 1 && timerValue===0) || (match.period === 4 && timerValue===0))
                    return 'Mi-temps'
                }

        }
  
        const totalTimer = getTotalTimer(match.period, timerValue, match.discipline)

        // 👇️ get number of full minutes
        const minutes = Math.floor(totalTimer / 60);

        // 👇️ get remainder of seconds
        const seconds = totalTimer % 60;

        function padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        }

        // ✅ format as MM:SS
        const result = `${padTo2Digits(minutes+1)}`;

        return result

    }, [timerValue, match.period, match.statusTimer, match.status])

    return getTimer
}